module.exports = "/images/lena-2.png?c3546ff0133efa2dc8ac8356d363260b";